__turbopack_context__.v({
  "alsoOn": "TaskFeedCard-module-scss-module__LyNN6W__alsoOn",
  "alsoOnItem": "TaskFeedCard-module-scss-module__LyNN6W__alsoOnItem",
  "alsoOnTitle": "TaskFeedCard-module-scss-module__LyNN6W__alsoOnTitle",
  "body": "TaskFeedCard-module-scss-module__LyNN6W__body",
  "brand": "TaskFeedCard-module-scss-module__LyNN6W__brand",
  "brandLogo": "TaskFeedCard-module-scss-module__LyNN6W__brandLogo",
  "brandLogoImg": "TaskFeedCard-module-scss-module__LyNN6W__brandLogoImg",
  "brandName": "TaskFeedCard-module-scss-module__LyNN6W__brandName",
  "brandRow": "TaskFeedCard-module-scss-module__LyNN6W__brandRow",
  "card": "TaskFeedCard-module-scss-module__LyNN6W__card",
  "content": "TaskFeedCard-module-scss-module__LyNN6W__content",
  "cover": "TaskFeedCard-module-scss-module__LyNN6W__cover",
  "coverImg": "TaskFeedCard-module-scss-module__LyNN6W__coverImg",
  "meta": "TaskFeedCard-module-scss-module__LyNN6W__meta",
  "metaDot": "TaskFeedCard-module-scss-module__LyNN6W__metaDot",
  "metaIcon": "TaskFeedCard-module-scss-module__LyNN6W__metaIcon",
  "metaItem": "TaskFeedCard-module-scss-module__LyNN6W__metaItem",
  "platform": "TaskFeedCard-module-scss-module__LyNN6W__platform",
  "platformIcon": "TaskFeedCard-module-scss-module__LyNN6W__platformIcon",
  "platformMore": "TaskFeedCard-module-scss-module__LyNN6W__platformMore",
  "platforms": "TaskFeedCard-module-scss-module__LyNN6W__platforms",
  "reward": "TaskFeedCard-module-scss-module__LyNN6W__reward",
  "rewardIcon": "TaskFeedCard-module-scss-module__LyNN6W__rewardIcon",
  "statsRow": "TaskFeedCard-module-scss-module__LyNN6W__statsRow",
  "status": "TaskFeedCard-module-scss-module__LyNN6W__status",
  "status_error": "TaskFeedCard-module-scss-module__LyNN6W__status_error",
  "status_info": "TaskFeedCard-module-scss-module__LyNN6W__status_info",
  "status_neutral": "TaskFeedCard-module-scss-module__LyNN6W__status_neutral",
  "status_success": "TaskFeedCard-module-scss-module__LyNN6W__status_success",
  "status_warning": "TaskFeedCard-module-scss-module__LyNN6W__status_warning",
  "title": "TaskFeedCard-module-scss-module__LyNN6W__title",
  "typeIcon": "TaskFeedCard-module-scss-module__LyNN6W__typeIcon",
  "typeLabel": "TaskFeedCard-module-scss-module__LyNN6W__typeLabel",
});
